import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { IExtra } from '@appNeo/core/interfaces/IExtra';
import { ExtrasService } from '@appNeo/core/services/extras/extras.service';
import { DEMO_SECCION_COMUNIONES_COMUNIONES } from '../inicio/seccion-edicion-data';

import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-comuniones',
  templateUrl: './comuniones.component.html',
  styleUrls: ['./comuniones.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ComunionesComponent implements OnInit {
  @Input() pathContacto: string = '/' + PAGINAS_ROUTES.PAGINA_CONTACTO;

  // secciones editables
  titulo = 'TIT';
  texto = 'TXT';
  imagen = [];
  secciones: [] = [];
  extras: IExtra[] = [];
  precargaMeta;
  constructor(
    private extraService: ExtrasService,
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    private route: ActivatedRoute,
    private confTitulo: ConfigTituloPaginasService
  ) { 
    this.subscripcionExtras();
    this.route.data.subscribe(
      response => {
        console.log('Data precargada', response);
        this.precargaMeta = response.seccionesEditables.precargaMeta;
      }
    );
  }

  ngOnInit(): void {
    this.secciones['comuniones_comuniones'] = DEMO_SECCION_COMUNIONES_COMUNIONES;
    this.iniciarPagina();
  }

  iniciarPagina(){
    if (this.helpersService.hayModulo('edicion')) {
      // **********************************
      // Titulo y meta
      // **********************************
      this.confTitulo.establecerTitulo('Comuniones', 'comuniones-meta', this.precargaMeta, 'meta-tit');
      this.confTitulo.establecerMeta(environment.descripcionMetaDefecto, 'comuniones-meta', this.precargaMeta, 'meta-des');

      this.edicionSeccionesService.getContenidoBloquesSubseccion('comuniones').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.titulo = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'comuniones-tit', indice);
          this.texto = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'comuniones-txt', indice);
          this.imagen = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'comuniones-img', indice);
          return;
        })

      })
    }
  }

  subscripcionExtras() {
    this.extraService.getAll(undefined, undefined, { orden: 'id', tipoOrden: 'asc' }).subscribe((extras: IExtra[]) => {
      this.extras = extras.filter(item => item.visiblePublico);
    });    
  }

}
